<style scoped>
.layout {
  border: 1px solid #d7dde4;
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-header-bar {
  background: #fff;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}
.menu-item span {
  display: inline-block;
  overflow: hidden;
  width: 69px;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
  transition: width 0.2s ease 0.2s;
}
.menu-item i {
  transform: translateX(0px);
  transition: font-size 0.2s ease, transform 0.2s ease;
  vertical-align: middle;
  font-size: 16px;
}
.collapsed-menu span {
  width: 0px;
  transition: width 0.2s ease;
}
.collapsed-menu i {
  transform: translateX(5px);
  transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
  vertical-align: middle;
  font-size: 22px;
}
</style>
<template>
  <div class="layout">
    <Layout>
      <Sider breakpoint="md" hide-trigger collapsible :collapsed-width="78" v-model="isCollapsed">
        <goal-filter style="padding: 4px 4px 0 4px;"></goal-filter>
        <assignment-tracking-filter style="padding: 4px;"></assignment-tracking-filter>
        <div slot="trigger"></div>
      </Sider>
      <Layout>
        <Header class="layout-header-bar"></Header>
        <Content :style="{ margin: '20px', background: '#fff', minHeight: '220px' }">
          Content
        </Content>
      </Layout>
    </Layout>
  </div>
</template>
<script>
import GoalFilter from "../components/assignments/goal-filter.vue";
import AssignmentTrackerFilter from "../components/assignments/assignment-tracker-filter.vue";

export default {
  components: { GoalFilter, AssignmentTrackerFilter },
  data() {
    return {
      isCollapsed: false
    };
  },
  computed: {
    menuitemClasses: function() {
      return ["menu-item", this.isCollapsed ? "collapsed-menu" : ""];
    }
  }
};
</script>